import React, { useCallback, useState } from 'react';
import { makeStyles, Pagination, SearchButton } from "../../../../index";
import { WorkSelectFilter } from "../../Filter/WorkSelectFilter";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        display: 'flex',
        justifyContent: 'flex-end',
        flex: '0 0 auto',
        zIndex: 5,
        paddingTop: theme.spacing(2),
    },
    sortLabel: {
        display: 'flex',
        alignItems: 'center',
        marginRight: theme.spacing(1),
    },
    searchButton: {
        width: 120,
    },
}); });
export var WorkSelectDialogToolbar = React.memo(function (props) {
    var pagination = props.pagination, filterCondition = props.filterCondition, isFilterEmpty = props.isFilterEmpty, onFilterChange = props.onFilterChange, onFilterClear = props.onFilterClear, onChangePagination = props.onChangePagination;
    var classes = useStyles();
    var _a = useState(null), anchorRef = _a[0], setAnchorRef = _a[1];
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var handleOpen = useCallback(function (event) {
        setOpen(function (prev) { return !prev; });
        event.preventDefault();
    }, []);
    var handleClose = useCallback(function () {
        setOpen(false);
    }, []);
    var handleFilterSelect = useCallback(function (receivedFilterCondition) {
        onFilterChange(receivedFilterCondition);
        setOpen(false);
    }, [onFilterChange]);
    var handleFilterClear = useCallback(function () {
        onFilterClear();
        setOpen(false);
    }, [onFilterClear]);
    return (React.createElement("div", { className: classes.root },
        React.createElement(Pagination, { page: pagination.page, lastPage: pagination.lastPage, onChange: onChangePagination }),
        React.createElement(SearchButton, { ref: setAnchorRef, onClick: handleOpen, isBadgeVisible: !isFilterEmpty, className: classes.searchButton }),
        React.createElement(WorkSelectFilter, { open: open, anchorEl: anchorRef, filterCondition: filterCondition, onFilterSelect: handleFilterSelect, onFilterClear: handleFilterClear, onCloseFilter: handleClose })));
});
